import { Link } from 'react-router-dom';

import styles from './NotFoundPage.module.css';

/**
 * NotFoundPage Component
 *
 * 404 error page displayed when user navigates to non-existent route
 * Includes navigation back to home page
 */
const NotFoundPage = (): JSX.Element => {
  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.content}>
        <h1 className={styles.title}>404</h1>
        <h2 className={styles.subtitle}>Page Not Found</h2>
        <p className={styles.message}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className={styles.homeLink}>
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
